// extracted by mini-css-extract-plugin
export default {"social_card":"Styles_social_card__ivY7C","headerHeight":"Styles_headerHeight__jFx4J"};